import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { SkuWarnings } from "@/lib/contentful/material";
export const materialWarningsQueryKey = ["material-warnings"];
export const useMaterialWarnings = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: materialWarningsQueryKey,
      staleTime: 3600000,
      queryFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};
async function _temp() {
  const response = await fetch("/api/materials/warnings");
  if (!response.ok) {
    throw new Error(`Failed to fetch material warnings: ${response.status}`);
  }
  return response.json();
}